export default "__VITE_ASSET__i3iP8Wqp__"